/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TalentPoolImportSkippedRow } from './talentPoolImportSkippedRow';

export interface TalentPoolImportResponse {
  created: number;
  updated: number;
  linked: number;
  skipped: TalentPoolImportSkippedRow[];
}
